import { createFileRoute } from '@tanstack/react-router'
import Component from "./-components/component"
import { ShiftHistoryParams } from './-data/model';
import { ListShiftsResponse } from "@/gen/shifts/list_shifts_pb";
import { pharmacyClient } from "@/connect";


export const Route = createFileRoute("/(pharma)/_layout/reports/shift-history/")
    ({
        component: Component,
        validateSearch: ShiftHistoryParams,
    });
